module.exports = __webpack_public_path__ + "img/galaxy-bg.7dbfcd87.jpg";